import { atom } from 'recoil';

type Status = 'idle' | 'loading' | 'success' | 'error';

export interface BannerActionStatusAtom {
  fetchList: Status;
}

export const bannerActionStatusAtom = atom<BannerActionStatusAtom>({
  key: 'bannerActionStatusAtom',
  default: {
    fetchList: 'idle'
  }
});

export const bannerListAtom = atom({
  key: 'bannerListAtom',
  default: {}
})

export const bannerErrorAtom = atom({
  key: 'bannerErrorAtom',
  default: {}
})

interface OrgListAtom {
  status: { fetchList: Status };
  list: Array<object>;
  data: any;
  error: any;
}